import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";

const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        userLogin: builder.mutation({
            query: (details) => ({
                url: '/Account/AdminLogin',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),

})

export const {
    useUserLoginMutation,
} = authApi;

export default authApi;